import PhotoCapturedBg from 'assets/ver2/images/photo-captured-bg.jpg';
import ButtonCommon from 'components/common/ButtonCommon';
import {
  DESKTOP_MIN_WIDTH,
  MOBILE_MIN_WIDTH,
  TABLET_MAX_WIDTH,
} from 'constants';
import useLang from 'hooks/useLang';
import usePortalModal from 'hooks/usePortalModal';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';
import {
  displayFlexColCenterCenterMixin,
  displayFlexRowCenterCenterMixin,
  scrollbarThumbMixin,
} from 'styles';

const RECT_WIDTH_DESKTOP = 400;
const RECT_WIDTH_MOBILE = 345;
const RECT_HEIGHT = 300;

const OVAL_WIDTH = 250;
const OVAL_HEIGHT = 300;

const PhotoCapturedResultPopup = ({ isOpen, onClick, onClose, modalData }) => {
  const { t } = useLang();
  const { closePortalModalName } = usePortalModal();

  const { imgSrc, captureType } = modalData || {};
  const isCaptureTypeID = captureType === 'id';

  const handleOnRetakePhotoCaptured = () => {
    console.log(
      `⭐ PhotoCapturedResultPopup 👉 handleOnRetakePhotoCaptured ➡️ RUNNING ↩`
    );
    onClose();
  };
  const handleOnSavePhotoCaptured = () => {
    console.log(
      `⭐ PhotoCapturedResultPopup 👉 handleOnSavePhotoCaptured ➡️ RUNNING ↩`
    );
    onClick();
    onClose();
    closePortalModalName();
  };
  const renderActionButton1 = (width) => (
    <ButtonCommon
      value={t('button_retake')}
      onClick={handleOnRetakePhotoCaptured}
      styles={{
        margin: '0px',
        height: '50px',
        width,
      }}
      color="var(--ds-c-blue)"
      background="var(--ds-c-white)"
    />
  );
  const renderActionButton2 = (width) => (
    <ButtonCommon
      value={t('button_save')}
      color="var(--c-primary)"
      background="var(--bg-primary)"
      isFill={true}
      styles={{
        margin: '0px',
        height: '50px',
        width,
      }}
      onClick={handleOnSavePhotoCaptured}
      isUseKeyDown
    />
  );
  const renderActionButtons = () => {
    return (
      <>
        {renderActionButton1('calc(50% - 6px)')}
        {renderActionButton2('calc(50% - 6px)')}
      </>
    );
  };

  const renderWebcamMask = () => {
    if (isCaptureTypeID) return <WebcamRectMask src={imgSrc} />;
    return <WebcamOvalMask src={imgSrc} />;
  };

  return (
    <>
      <style>
        {`
          .photo-captured-result-popup {
            z-index: 1071;
          }
        `}
        {`
          .photo-captured-result-popup-backdrop {
            z-index: 1070;
            background: #212121;
            opacity: 0.7!important;
            display: initial!important;
          }
        `}
      </style>
      <ModalStyled
        show={isOpen}
        onHide={() => {}}
        aria-labelledby="contained-modal-title-vcenter"
        className="photo-captured-result-popup"
        backdropClassName="photo-captured-result-popup-backdrop"
        centered
      >
        <ModalBody>
          <PhotoCapturedResultStyled>
            <BodyContent>
              <WebcamOverlay />
              {renderWebcamMask()}
            </BodyContent>
          </PhotoCapturedResultStyled>
        </ModalBody>
        <ModalFooter>{renderActionButtons()}</ModalFooter>
      </ModalStyled>
    </>
  );
};

const ModalStyled = styled(Modal)`
  padding-left: 0px !important;
  padding-right: 0px !important;

  @media screen and (min-width: ${MOBILE_MIN_WIDTH}px) and (max-width: ${TABLET_MAX_WIDTH -
    1}px) {
    & .modal-dialog {
      position: absolute;
      margin: 0;
      top: 0px;
      height: 100dvh;
      width: 100%;
      max-width: 100%;
      align-items: end;
      transition: ease-out 0.3s !important;
      transform: none;

      & .modal-content {
        padding: 0px 16px;
        box-shadow: none;
        background: var(--ds-c-white);
        width: 100%;
        min-height: 100dvh;
        max-height: 100dvh;
        margin-inline: auto;
        border: none;
        border-radius: 0;
      }
    }
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    & .modal-dialog {
      transform: none;
      & .modal-content {
        padding: 0px 16px;
        box-shadow: var(--ds-bs-4);
        background: var(--ds-c-white);
        width: 430px;
        height: 657px;
        margin-inline: auto;
        border: none;
        border-radius: 20px;
      }
    }
  }
`;

const ModalBody = styled(Modal.Body)`
  padding: 0;
  text-align: left;
  margin-bottom: 0px;
  overflow-x: auto;
  margin-inline: -16px;
  padding-inline: 16px;
  ${scrollbarThumbMixin};

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    overflow-x: unset;
    border-radius: 20px;
  }
`;

const PhotoCapturedResultStyled = styled.div`
  ${displayFlexColCenterCenterMixin};
  width: 100%;
  height: 100dvh;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    height: 100%;
  }
`;

const BodyContent = styled.div`
  ${displayFlexColCenterCenterMixin};
  max-width: 100%;
`;

const WebcamOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 0;
  background-image: url(${PhotoCapturedBg});
  background-position: top;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    border-radius: 18px;
  }
`;
const WebcamRectMask = styled.img`
  position: absolute;
  top: 54px;
  border-radius: 25px;
  margin-inline: auto;
  width: ${RECT_WIDTH_MOBILE}px;
  height: ${RECT_HEIGHT}px;
  object-fit: cover;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    width: ${RECT_WIDTH_DESKTOP}px;
  }
`;
const WebcamOvalMask = styled.img`
  position: absolute;
  top: 54px;
  border-radius: 200px;
  margin-inline: auto;
  border-radius: 200px;
  outline: 5px solid #ffffff;
  width: ${OVAL_WIDTH}px;
  height: ${OVAL_HEIGHT}px;
  object-fit: cover;
`;

const ModalFooter = styled(Modal.Footer)`
  ${displayFlexRowCenterCenterMixin};
  gap: 12px;
  padding-block: 0;
  padding-inline: 16px;
  border: none;
  width: 100%;
  position: fixed;
  bottom: 86px;
  left: 0;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    position: absolute;
    bottom: 74px;
  }
`;

export default PhotoCapturedResultPopup;
